import logo from '@/assets/owla-logo.svg';
import { normalizePath } from '@/routes.js';

/**
 * The one top navigation every page renders: brand, Home · Docs · Support, and
 * the download CTA. It used to be two different headers — the landing page's
 * pill nav and the `policy-header` back-link strip the other three shared — so
 * moving between them changed the chrome under the visitor.
 *
 * Labels are a prop because /docs and /support are bilingual; the English
 * set below is the default the English-only pages take.
 *
 * The bar scrolls away with the page on every route: /docs and /support scroll
 * long content past sticky furniture of their own (the guide rail, the form's
 * aside), and pinning a second bar over that only ate the screen they need.
 */

export const NAV_LABELS_EN = {
  home: 'Home',
  docs: 'Document',
  support: 'Support',
  cta: 'Try Owla',
};

export const NAV_LABELS_VI = {
  home: 'Trang chủ',
  docs: 'Hướng dẫn',
  support: 'Hỗ trợ',
  cta: 'Dùng thử Owla',
};

const DOCS_PATH = '/docs';
const SUPPORT_PATH = '/support';

export default function SiteNav({ labels = NAV_LABELS_EN, children }) {
  // Re-rendered by the router on every route change (main.jsx owns the path
  // state), so reading the location here stays correct without its own listener.
  const here = normalizePath(window.location.pathname);
  const onLanding = here === '/';

  const items = [
    { key: 'home', href: '/', match: '/', label: labels.home },
    { key: 'docs', href: DOCS_PATH, match: DOCS_PATH, label: labels.docs },
    { key: 'support', href: SUPPORT_PATH, match: SUPPORT_PATH, label: labels.support },
  ];

  return (
    <div className="nav">
      <div className="container">
        <div className="nav-pill">
          <a href="/" className="nav-brand">
            <img src={logo} alt="Owla" />
            <span className="nav-wordmark">Owla</span>
          </a>
          <nav className="nav-links" aria-label="Primary">
            {items.map((item) => {
              const current = item.match === here;
              return (
                <a
                  key={item.key}
                  href={item.href}
                  className={`nav-link${current ? ' is-current' : ''}`}
                  aria-current={current ? 'page' : undefined}
                >
                  {item.label}
                </a>
              );
            })}
          </nav>
          <div className="nav-end">
            {children}
            {/* The download section lives on the landing page, so off it the CTA
                has to travel there first. */}
            <a href={onLanding ? '#download' : '/#download'} className="nav-cta">
              {labels.cta}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
